const Image = (props) => {
  if (!props?.src) return

  return <img loading="lazy" src={props.src} alt={props.altText ? props.altText : ''} className={props.className} />
}

export default Image
